import UIComponent from "../ui/component";
import goals from "../utils/goals";

export class OfferSubscription extends UIComponent {
    init() {
        this.offer;

        this.payBtn.on("click", this.onPayBtnClick.bind(this));
    }

    update(data) {
        this.offer = data.id;
        this.title = data.title;
        this.sale = data.sale;
        this.pricePerMin = data?.formatted_minute_cost ?? '';
        this.offerTime = data.minutes;
        this.price = data.amount_formatted;
        this.payBtn.price = data.amount_formatted;
        this.highPrice = data.high_price ?? '';
    }

    onPayBtnClick(e) {
        e.preventDefault();

        goals.reach('subscription_selected');
        this.emit('payClick', { offer: this.offer });
    }
}
